import { create } from 'zustand';
import { ImageType, postImage } from './api/image-api';
import { useAlertStore } from './use-alert-store';

interface Store {
  postImage: (formData: FormData) => Promise<ImageType | undefined>;
  isLoading?: boolean;
  image?: ImageType;
}

export const useImageStore = create<Store>((set) => ({
  postImage: async (formData) => {
    set({ isLoading: true });
    let resp;
    try {
      resp = await postImage(formData);
      useAlertStore.getState().add({ label: 'Картинка успешно загружена', variant: 'success' });
      set({ image: resp });
    } catch (e) {
      console.error(e);
      useAlertStore.getState().add({ label: 'Не удалось загрузить картинку', variant: 'danger' });
    } finally {
      set({ isLoading: false });
    }
    return resp;
  },
}));
